import { useState } from 'react';

export default function EstrategiaPage() {
  const handleCTAClick = () => {
    window.open('https://wa.me/5517992668232?text=Olá, gostaria de solicitar um diagnóstico patrimonial', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navegação Superior */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#2C3539]/95 backdrop-blur-sm shadow-sm transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/eaa29081c8576d56531a963372a22dd6.png" 
            alt="Lilian Poli - Estratégia Patrimonial" 
            className="h-8 md:h-10 w-auto object-contain"
          />
        </div>
      </nav>

      {/* Conteúdo Principal */}
      <div className="pt-20 md:pt-32">
        
        {/* Seção de Filtragem */}
        <section className="py-12 md:py-24 px-4 md:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="mb-12 md:mb-16 text-center">
              <div className="inline-flex items-center gap-2 mb-4 md:mb-6">
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
                <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#B8935E] font-medium">Perfil Ideal</span>
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2C3539] font-light mb-4 px-4">
                Para Quem É Esta Estratégia
              </h2>
            </div>
            
            <div className="space-y-6 md:space-y-8">
              <div className="group hover:translate-x-2 transition-all duration-300">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F8F6F3] flex items-center justify-center flex-shrink-0 group-hover:bg-[#B8935E]/10 transition-colors">
                    <i className="ri-building-line text-[#B8935E] text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-medium text-[#2C3539] mb-1 md:mb-2">Empresários Visionários</h3>
                    <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                      Que buscam ampliar verticais de faturamento sem comprometer o caixa operacional
                    </p>
                  </div>
                </div>
              </div>

              <div className="group hover:translate-x-2 transition-all duration-300">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F8F6F3] flex items-center justify-center flex-shrink-0 group-hover:bg-[#B8935E]/10 transition-colors">
                    <i className="ri-home-heart-line text-[#B8935E] text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-medium text-[#2C3539] mb-1 md:mb-2">Famílias com Patrimônio Consolidado</h3>
                    <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                      R$ 500 mil a R$ 5 milhões+ que entendem o valor da disciplina financeira
                    </p>
                  </div>
                </div>
              </div>

              <div className="group hover:translate-x-2 transition-all duration-300">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F8F6F3] flex items-center justify-center flex-shrink-0 group-hover:bg-[#B8935E]/10 transition-colors">
                    <i className="ri-line-chart-line text-[#B8935E] text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-medium text-[#2C3539] mb-1 md:mb-2">Investidores Estratégicos</h3>
                    <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                      Que valorizam proteção patrimonial e construção de legado de longo prazo
                    </p>
                  </div>
                </div>
              </div>

              <div className="group hover:translate-x-2 transition-all duration-300">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F8F6F3] flex items-center justify-center flex-shrink-0 group-hover:bg-[#B8935E]/10 transition-colors">
                    <i className="ri-time-line text-[#B8935E] text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-medium text-[#2C3539] mb-1 md:mb-2">Visão de Longo Prazo</h3>
                    <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                      Que compreendem que o tempo é o maior aliado na construção de riqueza sustentável
                    </p>
                  </div>
                </div>
              </div>

              <div className="group hover:translate-x-2 transition-all duration-300">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F8F6F3] flex items-center justify-center flex-shrink-0 group-hover:bg-[#B8935E]/10 transition-colors">
                    <i className="ri-shield-check-line text-[#B8935E] text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-medium text-[#2C3539] mb-1 md:mb-2">Estratégia Sobre Sorte</h3>
                    <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                      Que preferem consultoria personalizada, não produtos de prateleira
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 md:mt-20 pt-8 md:pt-12 border-t border-[#2C3539]/5">
              <p className="text-center text-[#B8935E] italic text-base md:text-lg font-light px-4">
                Menos clientes, mais patrimônio. Qualidade sobre quantidade.
              </p>
            </div>
          </div>
        </section>

        {/* Seção de Repelência */}
        <section className="py-12 md:py-24 px-4 md:px-8 bg-[#F8F6F3]">
          <div className="max-w-5xl mx-auto">
            <div className="mb-12 md:mb-16 text-center">
              <div className="inline-flex items-center gap-2 mb-4 md:mb-6">
                <div className="w-1 h-1 rounded-full bg-[#2C3539]"></div>
                <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#2C3539]/60 font-medium">Transparência</span>
                <div className="w-1 h-1 rounded-full bg-[#2C3539]"></div>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2C3539] font-light mb-4 px-4">
                Para Quem Não É
              </h2>
            </div>
            
            <div className="space-y-5 md:space-y-6">
              <div className="flex items-start gap-3 md:gap-4 group">
                <div className="w-1.5 h-1.5 rounded-full bg-[#2C3539]/30 mt-2 md:mt-2.5 flex-shrink-0 group-hover:bg-[#2C3539] transition-colors"></div>
                <p className="text-base md:text-lg text-[#2C3539]/70 leading-relaxed">
                  Quem busca milagres financeiros ou promessas de enriquecimento rápido sem fundamento
                </p>
              </div>

              <div className="flex items-start gap-3 md:gap-4 group">
                <div className="w-1.5 h-1.5 rounded-full bg-[#2C3539]/30 mt-2 md:mt-2.5 flex-shrink-0 group-hover:bg-[#2C3539] transition-colors"></div>
                <p className="text-base md:text-lg text-[#2C3539]/70 leading-relaxed">
                  Imediatistas que não compreendem o valor da construção patrimonial de médio e longo prazo
                </p>
              </div>

              <div className="flex items-start gap-3 md:gap-4 group">
                <div className="w-1.5 h-1.5 rounded-full bg-[#2C3539]/30 mt-2 md:mt-2.5 flex-shrink-0 group-hover:bg-[#2C3539] transition-colors"></div>
                <p className="text-base md:text-lg text-[#2C3539]/70 leading-relaxed">
                  Pessoas sem disciplina financeira ou que não estão dispostas a seguir uma estratégia estruturada
                </p>
              </div>

              <div className="flex items-start gap-3 md:gap-4 group">
                <div className="w-1.5 h-1.5 rounded-full bg-[#2C3539]/30 mt-2 md:mt-2.5 flex-shrink-0 group-hover:bg-[#2C3539] transition-colors"></div>
                <p className="text-base md:text-lg text-[#2C3539]/70 leading-relaxed">
                  Quem procura apenas parcela baixa sem visão estratégica ou compreensão do valor do crédito
                </p>
              </div>

              <div className="flex items-start gap-3 md:gap-4 group">
                <div className="w-1.5 h-1.5 rounded-full bg-[#2C3539]/30 mt-2 md:mt-2.5 flex-shrink-0 group-hover:bg-[#2C3539] transition-colors"></div>
                <p className="text-base md:text-lg text-[#2C3539]/70 leading-relaxed">
                  Quem não está preparado para um atendimento consultivo e personalizado de alto nível
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Seção Provas Sociais */}
        <section className="py-16 md:py-32 px-4 md:px-8 bg-white relative overflow-hidden">
          {/* Aspas decorativas */}
          <div className="absolute top-8 left-8 md:top-16 md:left-16 text-[200px] md:text-[300px] font-serif text-[#B8935E]/[0.04] leading-none select-none pointer-events-none">"</div>
          <div className="absolute bottom-8 right-8 md:bottom-16 md:right-16 text-[200px] md:text-[300px] font-serif text-[#B8935E]/[0.04] leading-none select-none pointer-events-none rotate-180">"</div>

          <div className="max-w-6xl mx-auto relative z-10">
            <div className="text-center mb-12 md:mb-20">
              <div className="inline-flex items-center gap-2 mb-4 md:mb-6">
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
                <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#B8935E] font-medium">Resultados Reais</span>
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2C3539] font-light mb-4 md:mb-6 px-4">
                O Que Nossos Clientes Dizem
              </h2>
              <p className="text-base md:text-lg text-[#2C3539]/50 font-light max-w-2xl mx-auto px-4">
                Conversas reais de clientes que transformaram crédito em patrimônio
              </p>
            </div>

            {/* Grid de prints */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {/* Primeira prova social - IMAGEM REAL */}
              <div className="group bg-white rounded-2xl border border-[#E8E2D8] shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-500 overflow-hidden cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/754fa81a7b05d531c3909d5790afa639.jpeg" 
                  alt="Depoimento de cliente - Lais Zancanella"
                  className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>

              {/* Segunda prova social - IMAGEM REAL */}
              <div className="group bg-white rounded-2xl border border-[#E8E2D8] shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-500 overflow-hidden cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/d078ef721aff723e324caca4f0f1a7f7.jpeg" 
                  alt="Depoimento de cliente - Lais Damacena"
                  className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>

              {/* Terceira prova social - IMAGEM REAL */}
              <div className="group bg-white rounded-2xl border border-[#E8E2D8] shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-500 overflow-hidden cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/0fa3ec89350a34310b2f31d9a4cc1a4c.jpeg" 
                  alt="Depoimento de cliente - Vinícius Morais"
                  className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>

              {/* Quarta prova social - IMAGEM REAL */}
              <div className="group bg-white rounded-2xl border border-[#E8E2D8] shadow-[0_4px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-500 overflow-hidden cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/918a5b8045afa339606e0b2394a76a65.jpeg" 
                  alt="Depoimento de cliente - Bruno Mariano"
                  className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>
            </div>

            {/* Estatística de credibilidade */}
            <div className="mt-12 md:mt-20 flex flex-col items-center gap-4">
              <div className="inline-flex items-center gap-3 bg-[#F8F6F3] px-6 md:px-8 py-3 md:py-4 rounded-full">
                <div className="flex -space-x-1">
                  <i className="ri-star-fill text-[#D4AF37] text-sm"></i>
                  <i className="ri-star-fill text-[#D4AF37] text-sm"></i>
                  <i className="ri-star-fill text-[#D4AF37] text-sm"></i>
                  <i className="ri-star-fill text-[#D4AF37] text-sm"></i>
                  <i className="ri-star-fill text-[#D4AF37] text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-[#2C3539]/70 font-medium uppercase tracking-wider">
                  100+ clientes satisfeitos
                </span>
              </div>
              <p className="text-sm text-[#2C3539]/40 font-light italic">
                Resultados reais de clientes que confiaram na estratégia
              </p>
            </div>
          </div>
        </section>

        {/* Seção Metodologia */}
        <section className="py-16 md:py-32 px-4 md:px-8 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 md:mb-24">
              <div className="inline-flex items-center gap-2 mb-4 md:mb-6">
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
                <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#B8935E] font-medium">Metodologia</span>
                <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2C3539] font-light mb-4 md:mb-6 px-4">
                O Diferencial Estratégico
              </h2>
              <p className="text-lg md:text-xl text-[#2C3539]/50 font-light max-w-2xl mx-auto px-4">
                Como transformamos crédito em alavancagem patrimonial
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-10 md:gap-16 mb-16 md:mb-24">
              <div className="group">
                <div className="mb-6 md:mb-8">
                  <span className="text-5xl md:text-7xl font-light text-[#B8935E]/20 group-hover:text-[#B8935E]/40 transition-colors">01</span>
                </div>
                <h3 className="text-xl md:text-2xl font-light text-[#2C3539] mb-4 md:mb-6 tracking-tight">
                  Proteção de Caixa Inteligente
                </h3>
                <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                  O consórcio disciplina o investidor e protege o fluxo de caixa. Enquanto outros métodos drenam recursos com juros compostos, nossa estratégia preserva seu capital operacional e permite crescimento sustentável sem comprometer a saúde financeira do negócio ou da família.
                </p>
              </div>

              <div className="group">
                <div className="mb-6 md:mb-8">
                  <span className="text-5xl md:text-7xl font-light text-[#B8935E]/20 group-hover:text-[#B8935E]/40 transition-colors">02</span>
                </div>
                <h3 className="text-xl md:text-2xl font-light text-[#2C3539] mb-4 md:mb-6 tracking-tight">
                  Estratégia Sob Medida
                </h3>
                <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                  Não trabalhamos com sorte ou produtos genéricos. Cada carta de crédito é estruturada estrategicamente para seu perfil patrimonial. Operamos com valores robustos (R$ 250 mil a R$ 450 mil) focados em resultados sólidos e alavancagem real, não em ilusões de mercado.
                </p>
              </div>

              <div className="group">
                <div className="mb-6 md:mb-8">
                  <span className="text-5xl md:text-7xl font-light text-[#B8935E]/20 group-hover:text-[#B8935E]/40 transition-colors">03</span>
                </div>
                <h3 className="text-xl md:text-2xl font-light text-[#2C3539] mb-4 md:mb-6 tracking-tight">
                  Alavancagem Sem Juros Abusivos
                </h3>
                <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                  Transforme crédito em ativo sem depender de financiamentos tradicionais que corroem seu patrimônio. Nossa metodologia permite que você expanda verticais de faturamento, adquira imóveis estratégicos ou diversifique investimentos mantendo o controle total sobre seu capital.
                </p>
              </div>

              <div className="group">
                <div className="mb-6 md:mb-8">
                  <span className="text-5xl md:text-7xl font-light text-[#B8935E]/20 group-hover:text-[#B8935E]/40 transition-colors">04</span>
                </div>
                <h3 className="text-xl md:text-2xl font-light text-[#2C3539] mb-4 md:mb-6 tracking-tight">
                  Construção de Legado
                </h3>
                <p className="text-sm md:text-base text-[#2C3539]/60 leading-relaxed">
                  Mais do que uma transação financeira, estruturamos um plano de longo prazo para você e sua família. O tempo se torna seu aliado na construção de um patrimônio sólido e sustentável, com disciplina e visão estratégica que transcende gerações.
                </p>
              </div>
            </div>

            <div className="max-w-3xl mx-auto text-center py-12 md:py-16 border-t border-b border-[#2C3539]/5 px-4">
              <p className="text-lg md:text-2xl text-[#2C3539] leading-relaxed font-light italic">
                Consórcio não é sobre sorte. É sobre estratégia, disciplina e visão de futuro. É sobre transformar crédito em alavancagem inteligente.
              </p>
            </div>
          </div>
        </section>

        {/* Seção Sobre Lilian Poli */}
        <section className="py-16 md:py-32 px-4 md:px-8 bg-[#F8F6F3]">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
              <div className="order-2 md:order-1">
                <div className="inline-flex items-center gap-2 mb-6 md:mb-8">
                  <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
                  <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#B8935E] font-medium">Sobre a Estrategista</span>
                  <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
                </div>
                
                <h2 className="text-4xl md:text-5xl font-serif text-[#2C3539] font-light mb-8 md:mb-12">
                  Lilian Poli
                </h2>

                <div className="space-y-5 md:space-y-6 text-sm md:text-base text-[#2C3539]/70 leading-relaxed">
                  <p>
                    Lilian Poli não é uma vendedora de consórcio. Ela é uma <strong className="text-[#2C3539] font-medium">estrategista patrimonial</strong> que atua como consultora de alavancagem para empresários e famílias que buscam crescimento sustentável.
                  </p>

                  <p>
                    Com uma abordagem que foge completamente do estereótipo tradicional do mercado, Lilian aplica em sua própria vida as estratégias que compartilha com seus clientes. <strong className="text-[#2C3539] font-medium">Skin in the game</strong> não é apenas um conceito para ela — é um princípio de vida.
                  </p>

                  <p className="italic text-[#B8935E]">
                    "Consórcio disciplina o investidor, protege o caixa e transforma crédito em alavancagem sem depender de juros."
                  </p>

                  <p>
                    Trabalhando com cartas de crédito de diversos valores, Lilian foca em <strong className="text-[#2C3539] font-medium">qualidade, não quantidade</strong>. Seu atendimento é personalizado e estratégico, garantindo que cada cliente receba a orientação adequada para seu momento e objetivos patrimoniais.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-6 md:gap-8 mt-12 md:mt-16 pt-8 md:pt-12 border-t border-[#2C3539]/10">
                  <div>
                    <p className="text-2xl md:text-3xl font-light text-[#B8935E] mb-2">Diversos Valores</p>
                    <p className="text-xs text-[#2C3539]/50 uppercase tracking-wider">Cartas Estratégicas</p>
                  </div>
                  <div>
                    <p className="text-2xl md:text-3xl font-light text-[#B8935E] mb-2">Atendimento</p>
                    <p className="text-xs text-[#2C3539]/50 uppercase tracking-wider">Personalizado</p>
                  </div>
                </div>
              </div>

              <div className="order-1 md:order-2">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-br from-[#B8935E]/10 to-transparent rounded-3xl"></div>
                  <img 
                    src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/98208d7c8a12cbc818ca697ea0d51909.jpeg" 
                    alt="Lilian Poli - Estrategista Patrimonial"
                    className="relative w-full h-auto rounded-2xl shadow-2xl object-cover hover:scale-[1.02] transition-all duration-700"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Seção CTA Final */}
        <section className="py-16 md:py-32 px-4 md:px-8 bg-[#2C3539] relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 right-0 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-[#B8935E] rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-[#B8935E] rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-4xl mx-auto text-center relative z-10">
            <div className="inline-flex items-center gap-2 mb-6 md:mb-8">
              <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
              <span className="text-xs uppercase tracking-[0.2em] md:tracking-[0.3em] text-[#B8935E] font-medium">Atendimento Exclusivo</span>
              <div className="w-1 h-1 rounded-full bg-[#B8935E]"></div>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white font-light leading-tight mb-6 md:mb-8 px-4">
              Está Pronto Para Transformar<br className="hidden md:block" />
              Crédito em Alavancagem Patrimonial?
            </h2>

            <p className="text-base md:text-lg text-white/60 leading-relaxed mb-12 md:mb-16 max-w-2xl mx-auto font-light px-4">
              Solicite um diagnóstico patrimonial personalizado e descubra como estruturar uma estratégia sob medida para o seu perfil. Focamos na qualidade do portfólio, não na quantidade de clientes.
            </p>

            <button 
              onClick={handleCTAClick}
              className="group inline-flex items-center justify-center gap-3 bg-[#B8935E] hover:bg-[#C9A46F] text-white font-light text-sm md:text-base px-6 md:px-10 py-4 md:py-5 rounded-full transition-all duration-300 hover:scale-105 whitespace-normal md:whitespace-nowrap cursor-pointer text-center w-full md:w-auto max-w-md mx-auto"
            >
              <span className="uppercase tracking-[0.15em] md:tracking-[0.2em] leading-tight">Solicitar Diagnóstico Patrimonial</span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
            </button>

            <div className="mt-6 flex items-center justify-center gap-2">
              <i className="ri-whatsapp-line text-[#B8935E] text-xl"></i>
              <a 
                href="https://wa.me/5517992668232" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors text-base md:text-lg font-light tracking-wide cursor-pointer"
              >
                (17) 99266-8232
              </a>
            </div>

            <p className="text-xs md:text-sm text-white/40 font-light mt-8 md:mt-10 px-4">
              Vagas limitadas · Atendemos apenas clientes qualificados com patrimônio consolidado
            </p>
          </div>
        </section>

      </div>

      {/* Rodapé Minimalista */}
      <footer className="bg-[#1A1A1A] py-8 md:py-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <img 
            src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/eaa29081c8576d56531a963372a22dd6.png" 
            alt="Lilian Poli" 
            className="h-6 md:h-8 w-auto object-contain mx-auto mb-4 md:mb-6 opacity-60"
          />
          <p className="text-xs text-gray-600 font-light tracking-wide">
            © 2025 Lilian Poli - Estratégia Patrimonial. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}
